import { render } from "./SidebarMenuLink.vue?vue&type=template&id=5885f8d1"
import script from "./SidebarMenuLink.vue?vue&type=script&lang=js"
export * from "./SidebarMenuLink.vue?vue&type=script&lang=js"

import "./SidebarMenuLink.vue?vue&type=style&index=0&id=5885f8d1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__